import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

interface GeneralState {
  phone: string | null
  setPhone: (phone: string) => void
  cooldown: number
  setCooldown: (cooldown: number) => void
  email: string | null
  setEmail: (email: string | null) => void
  lat: number | null
  setLat: (lat: number) => void
  lng: number | null
  setLng: (lng: number) => void
  showChat: boolean
  setShowChat: (showChat: boolean) => void

  bubbleActive: boolean
  setBubbleActive: (bubbleActive: boolean) => void
  password: boolean
  setPassword: (password: boolean) => void
  chatToken: string | null
  setChatToken: (chatToken: string) => void
}

export const useGeneralStore = create<GeneralState>()(
  devtools(
    persist(
      (set) => ({
        phone: null,
        cooldown: 0,
        email: null,
        password: false,
        lat: null,
        lng: null,
        showChat: false,
        bubbleActive: true,
        chatToken: null,
        setPhone: (phone: string) => set({ phone }, false, 'setPhone'),
        setCooldown: (cooldown: number) => set({ cooldown }, false, 'setCooldown'),
        setEmail: (email: string | null) => set({ email }, false, 'setEmail'),
        setLat: (lat: number) => set({ lat }, false, 'setLat'),
        setLng: (lng: number) => set({ lng }, false, 'setLng'),
        setShowChat: (showChat: boolean) => set({ showChat }, false, 'setShowChat'),
        setBubbleActive: (bubbleActive: boolean) => set({ bubbleActive }, false, 'setBubbleActive'),
        setPassword: (password: boolean) => set({ password }, false, 'setPassword'),
        setChatToken: (chatToken: string) => set({ chatToken }, false, 'setChatToken'),
      }),
      {
        name: 'general-storage',
        storage: createJSONStorage(() => sessionStorage),
        partialize: (state: GeneralState) => ({ email: state.email, password: state.password }),
      },
    ),
    { name: 'GeneralStore' },
  ),
)
